module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.product) ? _c('div', {
    staticClass: "p-images",
    class: {
      'hide-bottom': (_vm.product.downPayment && _vm.product.downPayment.discount)
    }
  }, [(!_vm.isApp && !_vm.nocache) ? _c('div', {
    staticClass: "detail-menu-wrap"
  }, [_c('menu-tab')], 1) : _vm._e(), _vm._v(" "), (!_vm.isApp && !_vm.nocache) ? _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.product),
      expression: "product"
    }],
    staticClass: "icon",
    class: _vm.favoriteClass,
    on: {
      "click": _vm.favorite
    }
  }) : _vm._e(), _vm._v(" "), _c('swiper', {
    attrs: {
      "config": _vm.swiper,
      "paginateCls": _vm.swiper.paginateCls
    }
  }, [_vm._l((_vm.product.videos), function(video, index) {
    return (_vm.product.videos.length) ? _c('div', {
      staticClass: "swiper-slide"
    }, [_c('div', {
      staticClass: "product-video",
      class: 'p' + index
    }, [_c('beast-video', {
      attrs: {
        "wrap": 'p' + index,
        "isHeight": true,
        "poster": _vm.ensureImage(video.thumbnailUrl),
        "autoplay": false,
        "source": video.url,
        "controls": true
      }
    })], 1)]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.product.images), function(item) {
    return _c('div', {
      staticClass: "swiper-slide"
    }, [(_vm.soldOut) ? _c('div', {
      staticClass: "mask"
    }) : _vm._e(), _vm._v(" "), _c('beast-image', {
      attrs: {
        "src": _vm.ensureImage(item)
      }
    }), _vm._v(" "), (!_vm.product.invisible && !_vm.product.buyable) ? _c('div', {
      staticClass: "stats-tag buyable"
    }, [_c('span', [_vm._v("该渠道不可售")])]) : _vm._e(), _vm._v(" "), (_vm.product.foretell) ? _c('div', {
      staticClass: "stats-tag"
    }, [_c('span', [_vm._v("即将开售")])]) : _vm._e(), _vm._v(" "), (_vm.soldOut) ? _c('div', {
      staticClass: "stats-tag"
    }, [_c('span', [_vm._v("售罄")])]) : _vm._e(), _vm._v(" "), ((!_vm.nocache && _vm.product.offShelf) || _vm.product.invisible) ? _c('div', {
      staticClass: "stats-tag"
    }, [_c('span', [_vm._v("下架")])]) : _vm._e()], 1)
  })], 2), _vm._v(" "), (_vm.isToast) ? _c('div', {
    staticClass: "toast-box"
  }, [_c('h2', [_vm._v(_vm._s(_vm.toastTitle))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.toastContent))])]) : _vm._e(), _vm._v(" "), (!_vm.product.prevue && _vm.djsformat) ? _c('div', {
    staticClass: "forecast-detail"
  }, [_c('span', {
    staticClass: "forecast-detail-name"
  }, [_vm._v("限时抢购")]), _vm._v(" "), _c('span', {
    staticClass: "forecast-detail-price"
  }, [_vm._v(_vm._s(_vm.djsformat) + " 后恢复原价")])]) : _vm._e(), _vm._v(" "), (_vm.product.prevue) ? _c('div', {
    staticClass: "forecast-detail forecast-ys"
  }, [_c('div', {
    staticClass: "left-box"
  }, [_c('div', {
    staticClass: "forecast-detail-item name"
  }, [_vm._v("即将开售: " + _vm._s(_vm.prevueFormatNew) + " 开售")]), _vm._v(" "), (_vm.product.prevue.desc) ? _c('div', {
    staticClass: "forecast-detail-item desc"
  }, [_vm._v(_vm._s(_vm.product.prevue.desc))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "right-box"
  }, [_c('span', {
    staticClass: "forecast-detail-price",
    class: {
      'two': _vm.product.prevue.desc
    },
    on: {
      "click": function($event) {
        return _vm.doReminder(_vm.product.prevue.id, _vm.product.prevue.remind)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.product.prevue.remind ? '关闭提醒' : '开售提醒') + "\n      ")])])]) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11e3a712"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/app-product-detail/components/product-images.vue
// module id = 996
// module chunks = 2